class LogoMarqueeChroxel {
  constructor(container) {
    this.container = container;
    this.speed = Number(container.dataset.speed) || 80;
    this.parallax = Number(container.dataset.parallax) || 0;
    this.pauseOnHover = container.classList.contains('logo-marquee-chroxel--pause-hover');
    this.tracks = [];
    this.visible = true;
    this.lastScrollY = window.scrollY;
    this.lastTime = null;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    container.querySelectorAll('.logo-marquee-chroxel__track').forEach((el) => {
      const band = el.closest('.logo-marquee-chroxel__band');
      const sign = band && band.dataset.direction === 'right' ? -1 : 1;
      el.classList.add('logo-marquee-chroxel__track--js');
      this.tracks.push({ el, band, sign, hovered: false, position: 0, groupWidth: 0 });
    });

    if (this.tracks.length === 0) return;

    this.setup();
    window.addEventListener('resize', () => this.setup());
    window.addEventListener('load', () => this.setup());
    window.addEventListener('scroll', () => this.onScroll(), { passive: true });

    if (this.pauseOnHover) {
      // Pause each band independently while the cursor is over it
      this.tracks.forEach((track) => {
        if (!track.band) return;
        track.band.addEventListener('mouseenter', () => {
          track.hovered = true;
        });
        track.band.addEventListener('mouseleave', () => {
          track.hovered = false;
        });
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.visible = entry.isIntersecting;
        });
      }).observe(container);
    }

    window.requestAnimationFrame((time) => this.tick(time));
  }

  setup() {
    const containerWidth = this.container.offsetWidth;
    this.tracks.forEach((track) => {
      const group = track.el.querySelector('.logo-marquee-chroxel__group');
      if (!group) return;
      const groupWidth = group.offsetWidth;
      if (groupWidth <= 0) return;

      const needed = Math.ceil((containerWidth * 1.4) / groupWidth) + 2;
      while (track.el.children.length < needed) {
        const clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
        track.el.appendChild(clone);
      }
      track.groupWidth = groupWidth;
    });
  }

  onScroll() {
    const delta = window.scrollY - this.lastScrollY;
    this.lastScrollY = window.scrollY;
    if (!this.visible) return;

    this.tracks.forEach((track) => {
      track.position += delta * this.parallax * track.sign;
    });
  }

  tick(time) {
    if (this.lastTime === null) this.lastTime = time;
    const dt = Math.min((time - this.lastTime) / 1000, 0.1);
    this.lastTime = time;

    if (this.visible) {
      this.tracks.forEach((track) => {
        if (!track.hovered) {
          track.position += this.speed * dt * track.sign;
        }
        if (track.groupWidth > 0) {
          const x = ((track.position % track.groupWidth) + track.groupWidth) % track.groupWidth;
          track.el.style.transform = `translate3d(${-x.toFixed(2)}px, 0, 0)`;
        }
      });
    }

    window.requestAnimationFrame((t) => this.tick(t));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.logo-marquee-chroxel').forEach((el) => {
    new LogoMarqueeChroxel(el);
  });
});
